// Question Bank
export const BASE_QUESTION = "/api/question";

// Assessment
export const BASE_ASSESSMENT = "/api/test";

// Results
export const BASE_RESULTS = "/api/results";
